export default __webpack_public_path__ + "static/media/erreur.5c901a1e.jpg";